/**
 * A meeting name as display text, for the surfaces a visitor sees.
 *
 * The type check is the whole implementation on purpose. `meetings` documents
 * are read with a cast rather than a parse, so `name` is a claim, not a
 * guarantee — and a non-string reaching React as a child throws. Answering
 * "is this a usable name?" directly handles every shape by construction.
 *
 * The admin formatter (`formatScrapeReviewValue`) also coerces safely, and an
 * earlier version of this delegated to it and then remapped its output. That
 * was wrong twice over: it only rescued the empty shapes, so an object still
 * reached the public sentence as `{"evil":1}`, and it re-derived by string
 * equality a decision that helper had already made structurally, so renaming a
 * placeholder there would silently change what the public sees. Its vocabulary
 * belongs to a reviewer's diff table — "…you encountered with **—**:" is not a
 * sentence, and a screen reader announces it as "em dash".
 */
export const reportMeetingName = (meetingName: unknown): string =>
  typeof meetingName === 'string' && meetingName.trim() !== ''
    ? meetingName
    : 'this meeting';
